/**
 * 포인트 채굴기(CPU) 공통 설정 파일
 *
 * 여러 화면에서 공통으로 쓰는 상수를 중앙 관리한다.
 * 오퍼월을 추가/삭제할 때는 이 파일만 수정하면 된다.
 */

/**
 * 오퍼월 키 목록
 * - 전면이벤트(Game_EventNoti), 서버설정 > 이벤트탭 > 채굴탭 행성 링크 이벤트(Game_Setting) 등에서 공통 사용
 * - 값: 서버/게임에서 사용하는 오퍼월 키 (대문자)
 */
export const OFFERWALL_KEYS = [
    'SNAPPLAY',
    'TNK',
    'NSTATION',
    'MAF',
    'CPX',
    'POPCON',
    'GMOAD',
    'TYRADS',
    'DT',
    'ADJ',
    'MALLPIE',
];

export default {
    OFFERWALL_KEYS,
};
